import Form from "./VideoForm";
import CreateButton from "./VideoCreateButton";
import Preview from "./VideoPreview";
import ListItem from "./VideoListItem";
import List from "./VideoList";
import Input from "./VideoInput";
import Carousel from "./VideoCarousel";
import One from "./VideoOne";
import Grid from "./VideoGrid";

export default {
  Form,
  CreateButton,
  Preview,
  ListItem,
  List,
  Input,
  Carousel,
  One,
  Grid,
};
